<template>
  <v-container class="communications-main" id="communications-container">
    <div class="maintitle" v-if="!isMobile">{{ getTitle() }}</div>
    <div class="subtitle" v-if="showCommunications">
      {{ $t("Communications.readNotRead") }}
    </div>
    <div v-if="showCommunications">
      <div class="custom-select">
        <v-select
          v-model="type"
          :items="types"
          item-text="text"
          item-value="id"
          solo
          @change="typeChanged"
          class="communication-select"
          height="35px"
        >
          <template v-slot:item="{ item }">
            <span class="custom-select-item">
              {{ item.text }}
            </span>
          </template></v-select
        >
      </div>
      <div>
        <communication-table
          :items="communications"
          :fromHistory="false"
        ></communication-table>
      </div>
    </div>

    <!-- detail -->
    <div v-if="!showCommunications" class="generic-box">
      <div class="div-title" v-if="isMobile">
        <span>{{ title }}</span>
        <span class="float-right">{{
          this.$genericClass.formatDate(acceptDate, true)
        }}</span>
      </div>
      <v-textarea
        v-model="message"
        readonly
        class="generic-textarea"
        no-resize
      ></v-textarea>
      <div class="buttons-div">
        <v-btn class="generic-button first" @click="back">{{
          $t("Misc.back")
        }}</v-btn
        ><v-btn class="generic-button" :disabled="commBtnClicked" @click="downloadAndAccept">{{
          !comRead
            ? $t("Communications.downloadAndAccept")
            : $t("Communications.download")
        }}</v-btn>
      </div>
    </div>
  </v-container>
</template>
<style>
.container.communications-main {
  width: auto;
}

.container.communications-main .maintitle {
  margin-bottom: 42px;
}

.container.communications-main .subtitle {
  margin-bottom: 10px;
  font: normal normal bold 20px/24px Lato;
  color: #6f767a;
}

.container.communications-main .buttons-div {
  position: relative;
  width: 100%;
  height: 50px;
  /* margin-left: 45px;
  margin-right: -45px; */
  padding-bottom: 81px;
}

.container.communications-main .generic-button {
  position: absolute;
  left: auto;
  right: 45px;
  transform: none;
}

.container.communications-main .generic-button.first {
  position: absolute;
  left: 45px;
  right: auto;
  transform: none;
}

.container.communications-main
  .generic-textarea
  .v-text-field
  > .v-input__control
  > .v-input__slot:before {
  border-style: none;
}

.container.communications-main .generic-box {
  margin: 0px 0px 0px;
}

.container.communications-main .div-title {
  padding-bottom: 40px;
}

@media (max-width: 600px) {
  .custom-select .v-text-field.v-text-field--solo .v-input__control {
    min-height: 35px;
  }

  .container.communications-main .generic-button.first,
  .container.communications-main .generic-button {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import communicationTable from "../components/communicationTable.vue";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";
import router from "@/router/index.js";
import HSApi from "../api/Hyperstorage/HSApi.js";

export default {
  components: { communicationTable },
  data() {
    return {
      isMobile: false,
      message: "",
      title: "",
      showCommunications: true,
      comRead: false,
      communications: [],
      acceptDate: "",
      type: null,
      id: null,
      commBtnClicked: false,
      types: [
        { id: null, text: Trans.i18n.t("Communications.allCommunications") },
        { id: true, text: Trans.i18n.t("Communications.readCommunications") },
        {
          id: false,
          text: Trans.i18n.t("Communications.notReadCommunications"),
        },
      ],
    };
  },

  computed: {
    communicationSelectedChanged: function () {
      return this.$store.getters.GET_communicationSelectedChanged;
    },
    refreshCommunications: function () {
      return this.$store.getters.GET_refreshCommunications;
    },
  },

  watch: {
    communicationSelectedChanged: {
      handler() {
        var communication = this.$store.getters.GET_communicationSelected;
        // console.log("communication selected", communication);
        this.showCommunications = false;
        this.message = communication.descrizione;
        this.title = communication.titolo;
        this.id = communication.id;
        this.comRead = communication.read;
        this.acceptDate = communication.dataAccettazione;
      },
    },
    refreshCommunications: {
      handler() {
        this.showCommunications = true;
      },
    },
  },

  created() {
    this.type = this.types[0];
    this.closeMenu();
    this.getCommunications(this.$GAUserAuth.user, null);
    this.setIsMobile();
    this.$store.commit("SET_setBreadcrumb", {
      backurl: "/",
      text: Trans.i18n.t("Communications.communications"),
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    typeChanged() {
      this.getCommunications(this.$GAUserAuth.user, this.type);
    },
    getCommunications(user, read) {
      MyFercamApi.GetCommunications(user.companyCode, user.username, read).then(
        (res) => {
          this.communications = res.data;
        }
      );
    },
    getTitle() {
      if (this.showCommunications) {
        return Trans.i18n.t("Communications.communications");
      } else {
        return this.title;
      }
    },
    back() {
      this.showCommunications = true;
      router.push({ name: "communications" }).catch((err) => {});
    },
    async downloadAndAccept() {
      this.commBtnClicked=true;
      
      // console.log("commBtnClicked", this.commBtnClicked);
      var res = await MyFercamApi.GetCommunication(this.id);      
      await this.downloadAttachments(res.data);

      if (!this.comRead) {
        // console.log("GetCommunication", res.data, "to be read");
        MyFercamApi.ReadCommunication(
          this.id,
          this.$GAUserAuth.user.username
        ).then((res) => {
          // update the grid
          this.getCommunications(this.$GAUserAuth.user, null);
          this.showCommunications = true;
          this.commBtnClicked=false;
          // update mail icon notifications
          this.$store.commit(
            "SET_communicationsUpdated",
            !this.$store.getters.GET_communicationsUpdated
          );
        })
        .catch((error) => {
          this.commBtnClicked=false;
        });
      }
      else {
        this.commBtnClicked=false;
      }
    },
    async downloadAttachments(communications) {
      if (communications.length == 1) {
        HSApi.Download(communications[0].fileGuid).then((res) => {
          //   console.log("download", res.data);
          saveAs(
            new Blob([res.data], { type: "application/pdf" }),
            communications[0].filename
          );
        });
      } else if (communications.length > 1) {
        let zip = await HSApi.DownloadZip(
          communications.map((a) => a.fileGuid)
        );

        saveAs(
          new Blob([zip.data], { type: "application/octet-stream" }),
          "package.zip"
        );
      }
    },
    closeMenu() {
      let showSM = {
        show: false,
        style: "color: #cecece",
      };

      this.$store.commit("SET_showSearchMenu", showSM);
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
  },
};
</script>


